import { FaqProps } from "@ft/components/common/Faq";

const jsonParserFaqData: FaqProps[] = [
  {
    question: "What is JSON formatting?",
    ans: "JSON formatting is a process of converting JSON data into a human-readable format. This helps in understanding and debugging the data more effectively.",
  },
  {
    question: "Why Use a JSON code Formatter?",
    ans: "Working with JSON can sometimes be challenging, especially when dealing with large, complex data structures. It helps you visualize your data, making it easier to understand the structure and identify any errors.",
  },
  {
    question: "How does this this formatter work?",
    ans: "Our code formatter works by parsing the input JSON data and then beautifying it using proper indentation and line breaks. This makes the data easier to read and understand.",
  },
  {
    question: "How to use JSON data Formatter?",
    ans: "Just load your JSON, and the system will validate, parse, and format it automatically. It outputs a well-structured, color-coded representation of your data, with collapsible brackets to help you navigate through your JSON document.",
  },
  {
    question: "How i can format a JSON file?",
    ans: "With the JSON Formatter, select the load file button which will prompt a popup window for file selection. Choose your desired JSON file and see the result.",
  },
  {
    question: "Does the JSON Formatter store or keep a record of my JSON data?",
    ans: "Certainly not! When you format JSON system process your data and returns it to you without storing or recording any of it.",
  },
  {
    question: "Does this tool validate JSON data?",
    ans: "Yes, It also validates the input data. If there are any errors in your JSON data, the tool will highlight them.",
  },
];

export default jsonParserFaqData;
